import { render, staticRenderFns } from "./Conceptospago.vue?vue&type=template&id=148c8d0e"
import script from "./Conceptospago.vue?vue&type=script&lang=js"
export * from "./Conceptospago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports